export default __webpack_public_path__ + "static/media/img8.b8cbfdc9.png";